export default {
  path: '/quality_check_tests',
  name: 'quality_check_tests',
  component: () => import('../components/qualitychecktest/Layout'),
  redirect: { name: 'QualityCheckTestList' },
  meta: {
    breadcrumb: 'qualitycheck.test.tests',
  },
  children: [
    {
      name: 'QualityCheckTestList',
      path: '',
      component: () => import('../views/qualitychecktest/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'QualityCheckTestCreate',
      path: 'new',
      component: () => import('../views/qualitychecktest/Create'),
      meta: {
        breadcrumb: 'global.add',
      },

    },
    {
      name: 'QualityCheckTestUpdate',
      path: ':id/edit',
      component: () => import('../views/qualitychecktest/Update'),
      meta: {
        breadcrumb: 'qualitycheck.test.test',
      },
    },
    {
      name: 'QualityCheckTestShow',
      path: ':id',
      component: () => import('../views/qualitychecktest/Show'),
      meta: {
        breadcrumb: 'qualitycheck.test.test',
      },
    }
  ]
};
